export const PROFILBILD_TYPEN: readonly string[] = ['image/jpeg', 'image/png'];
export const PROFILBILD_MAX_BYTES = 2 * 1024 * 1024;

const KANTE = 256;
const JPEG_QUALITAET = 0.88;

export class ProfilbildNichtLesbar extends Error {
  constructor() {
    super('Profilbild nicht lesbar');
    this.name = 'ProfilbildNichtLesbar';
  }
}

export function pruefeProfilbild(file: File): 'typ' | 'groesse' | null {
  if (!PROFILBILD_TYPEN.includes(file.type)) return 'typ';
  if (file.size > PROFILBILD_MAX_BYTES) return 'groesse';
  return null;
}

export function kilobyte(bytes: number): number {
  return Math.round(bytes / 1024);
}

export function megabyte(bytes: number): number {
  return Math.ceil((bytes * 10) / (1024 * 1024)) / 10;
}

export async function zuschneiden(file: File): Promise<Blob> {
  let bitmap: ImageBitmap;
  try {
    bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
  } catch {
    throw new ProfilbildNichtLesbar();
  }
  const canvas = document.createElement('canvas');
  canvas.width = KANTE;
  canvas.height = KANTE;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    bitmap.close();
    throw new ProfilbildNichtLesbar();
  }
  const seite = Math.min(bitmap.width, bitmap.height);
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, KANTE, KANTE);
  ctx.drawImage(bitmap, (bitmap.width - seite) / 2, (bitmap.height - seite) / 2, seite, seite, 0, 0, KANTE, KANTE);
  bitmap.close();
  return new Promise((resolve, reject) =>
    canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new ProfilbildNichtLesbar())), 'image/jpeg', JPEG_QUALITAET),
  );
}
